import { h } from 'preact'
import { statusLabel, safeT } from './ActivityIndicator.jsx'

/**
 * StatusAlert — shown during connecting phase (before AI bubble appears)
 * and for error states.
 *
 * Props: { status, i18n }
 * status: { code, text } | null
 */
export function StatusAlert({ status, i18n }) {
  if (!status) return null

  const isError = status.code === 'error'
  const fallback = safeT(i18n, 'ai.codes.start') || 'Feldolgozás...'
  const label    = statusLabel(status, i18n, isError ? status.code : fallback)

  return (
    <div class={`status-alert alert ${isError ? 'alert-danger' : 'alert-primary'} d-flex align-items-center mb-3`}>
      <div class="d-flex align-items-center">
        {isError
          ? <i class="bi bi-exclamation-triangle-fill me-2"></i>
          : <div class="spinner-border text-primary me-2" role="status" style="width:1rem;height:1rem;"><span class="visually-hidden">Loading...</span></div>
        }
        <span data-status-text>{label}</span>
      </div>
    </div>
  )
}
